import { saveRequiredDocument } from 'common/api/creditApplications';
import {
    handleCheckboxField,
    showReponseErrorsAsAlert,
} from 'common/utils/helpers';

import {
    SAVE_DOCUMENT,
    SAVE_DOCUMENT_FAILURE,
    SAVE_DOCUMENT_SUCCESS,
} from '../../actionTypes';
import { creditFileActions } from '../../reducer';

export default (values, callback) => (dispatch) => {
    if (!values.creditApplicationId) return;

    const newValues = {
        documents: handleCheckboxField(values.catalog_documents),
    };

    dispatch(creditFileActions[SAVE_DOCUMENT]());

    saveRequiredDocument(values.creditApplicationId, newValues)
        .then(() => {
            dispatch(creditFileActions[SAVE_DOCUMENT_SUCCESS]());
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                creditFileActions[SAVE_DOCUMENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
